import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export type CreditNudgeState = 'unarmed' | 'pending' | 'dismissed';

export const creditNudgeAtom = atomWithStorage<CreditNudgeState>(
  'credit-education-nudge',
  'unarmed'
);

export type CreditNudgePhase = 'idle' | 'open' | 'closing';

// Session-level display phase shared by every anchor the nudge can attach to
// (credit icon on desktop, user icon on mobile), so arming or dismissing in
// one place is reflected everywhere. 'closing' keeps the tooltip mounted
// while its fade-out animation plays.
export const creditNudgePhaseAtom = atom<CreditNudgePhase>('idle');
